import axios, {
  AxiosResponse,
  AxiosRequestConfig,
  RawAxiosRequestHeaders,
  AxiosProgressEvent,
} from 'axios';

export type RequestMethod =
  | 'get'
  | 'post'
  | 'put'
  | 'patch'
  | 'delete'
  | 'head';

export interface ResponseError {
  error: Error;
  response: AxiosResponse;
}

export interface RequestOptions extends Pick<
  AxiosRequestConfig,
  'responseType'
> {
  data?: {};
  params?: {};
  headers?: RawAxiosRequestHeaders;
  signal?: AbortSignal;
  onDownloadProgress?: (progressEvent: AxiosProgressEvent) => void;
  onUploadProgress?: (progressEvent: AxiosProgressEvent) => void;
}
export interface RequestHeaders {
  Authorization?: string;
  'Content-Type'?: string;
}

export const ignoreAxiosError = (_: Error) => {
  // noop
};

// use interceptor to transform authorization headers
axios.interceptors.request.use(
  config => {
    if ('Authorization' in config.headers) {
      config.headers['X-Authorization'] = config.headers['Authorization'];
      delete config.headers['Authorization'];
    }
    return config;
  },
  error => Promise.reject(error),
);

export const request = (
  url: string,
  method: RequestMethod = 'get',
  options: RequestOptions = {},
) =>
  axios.request({
    url,
    method,
    data: options.data,
    params: options.params,
    headers: options.headers,
    responseType: options.responseType,
    signal: options.signal,
    onDownloadProgress: options.onDownloadProgress,
    onUploadProgress: options.onUploadProgress,
  });

export const get = (url: string, options?: RequestOptions) =>
  request(url, 'get', options);

export const post = (url: string, options?: RequestOptions) =>
  request(url, 'post', options);

export const put = (url: string, options?: RequestOptions) =>
  request(url, 'put', options);

export const del = (url: string, options?: RequestOptions) =>
  request(url, 'delete', options);
export const head = (url: string, options?: RequestOptions) =>
  request(url, 'head', options);
